












import {
  Vue, Component, Watch, Prop,
} from 'vue-property-decorator';

import type { CssGenerator } from '@/logic/CSSGenerator';
import type { Analysis } from '@/data';
import { defaultTypes } from '@/data';
import { TagColorGenerator } from '@/logic/TagColorGenerator';
import type AnalysisActions from '@/logic/AnalysisActions';
import { FilterStyleGenerator } from '@/logic/FilterStyleGenerator';
import CssInjector from './CssInjector.vue';

/**
 * The main dezrann integration
 *
 * Displays a piece analysis and lets a user modify it
 */
@Component({
  components: {
    CssInjector,
  },
})
export default class ColorGenerator extends Vue {
  // Main states

  @Prop()
  analysis!: Analysis;

  @Prop({ required: false })
  actions?: AnalysisActions;

  colorGenerator: TagColorGenerator | null = null;

  generators: CssGenerator[] = [];

  mounted() {
    this.onAnalysisChange();
  }

  @Watch('analysis')
  onAnalysisChange() {
    this.colorGenerator = new TagColorGenerator();
    // Note: the order in the array matters
    // Here, analysis filters will always override default filters
    this.generators = [
      new FilterStyleGenerator(defaultTypes),
      this.colorGenerator,
      new FilterStyleGenerator(this.analysis.filters),
    ];
    this.updateTagColors();
  }

  // On any change to a label tag
  // (if a label tag is modified or deleted)
  // Check if new tag colors should be associated or freed
  @Watch('actions.tagEditCount')
  @Watch('analysis.templates', { deep: true })
  updateTagColors() {
    // Get all labels
    const labels = Object.values(this.analysis?.labels ?? {});
    // Get all tags used in any way
    const usedTags = labels.map((l) => l.tag);
    const customTemplateTags = this.analysis.templates.map((t) => t.tag);
    const currentTemplate = this.actions ? [this.actions.getTemplate().tag] : [];
    // Update the colors with all currently used tags
    this.colorGenerator?.updateUsedColors([
      ...customTemplateTags,
      ...usedTags,
      ...currentTemplate,
    ]);
  }
}

